angular.module("core")

.controller("zoomableImageModalController", function($attrs, $scope) {
    this.title = $attrs.title;
    this.image = $attrs.image;
    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/zoomable-image/zoomable-image.modal.js
// module id = 663
// module chunks = 0